<template>
    <div class="newest-offers catalogue-panel">

        <div id="preloaderSmall" class="preloader-small">
            <div class="circle-panel">
                <span class="spinner"></span>
            </div>
        </div>

        <div class="offer-wrapper">

            <template v-if="noResults">
                <h2 class="mt-5 p-5">{{ lang.noResults }}</h2>
            </template>

            <div class="offer-panel" v-for="offer in offers">
                <template v-if="offer.tag">
                    <div :class="`tag ${offer.tag}`">{{ lang[offer.tag] }}</div>
                </template>
                <!-- User Auth Check -->
                <template v-if="authentication === false">
                    <span class="checkbox-star-panel checkbox-star-false"
                          data-toggle="tooltip"
                          :data-original-title="lang.favoriteOffersRegistration">
                        <span class="checkbox-star">
                            <span type="checkbox" name="favourites"></span>
                            <span class="checkmark"></span>
                        </span>
                    </span>
                </template>
                <template v-else>
                    <span class="checkbox-star-panel"
                          data-toggle="tooltip"
                          :data-original-title="lang.favoriteOffers">
                        <label class="checkbox-star"
                               data-trigger="auth-true"
                               :data-item-key="offer.id">
                            <input type="checkbox" name="favourites" :checked="offer.favorited">
                            <span class="checkmark"></span>
                        </label>
                   </span>
                </template>
                <!-- ------------- -->
                <a :href="prefixEn + /properties/+ (typeof offer.slug !== 'undefined' ? offer.slug : '#')"
                   :title="offer.title"
                   class="offer">
                    <div class="offer-image">
                        <div class="offer-image-inner zoom"
                             :style="{ 'background-image': 'url(' + (offer.media.length ? offer.media[0].sizes.D : placeholderImg) + ')' }"></div>
                    </div>
                    <div class="offer-text">
                        <h5 class="offer-title">{{ offer.title }}</h5>
                        <div class="offer-text-row">
                            <span class="text-regular mr-2">{{ lang.location }}: </span>
                            <span class="text-regular ellipsis"
                                  v-if="authentication !== false">{{ offer.address }}</span>
                            <span class="text-regular ellipsis blur-effect-soft"
                                  v-else>{{ lang.sample_location }}</span>
                        </div>

                        <!-- User Auth Check -->
                        <!--<template v-if="authentication === false">
                            <div class="offer-row-price blur-effect-soft">
                                <span class="text-bold price">000 000 €</span>
                                <span class="text-bold area">000 {{ lang.square_meters_abbrv }} </span>
                            </div>
                        </template>-->
                        <template>
                            <div class="offer-row-price">
                                <span class="text-bold price">{{ offer.monthly_rent }} €</span>
                                <span class="text-bold area">{{ (offer.total_floorage ? offer.total_floorage  + ' ' + lang.square_meters_abbrv: '') }}</span>
                            </div>
                        </template>
                        <!-- ------------- -->

                        <div class="offer-footer-row">
                            <!--<button type="button" class="text-regular time-label" data-toggle="tooltip"
                                    data-placement="top" :title="offer.created_at">
                                {{ offer.created_at | moment("from", "now", true) }}
                            </button>-->
                            <span class="text-regular btn-label"> {{ lang.see_more }} </span>
                        </div>
                    </div>
                </a>
            </div>
        </div>

        <div class="pagination-panel" v-if="!noResults">
            <paginate
                    v-model="currentPage"
                    :page-count="pageCount"
                    :page-range="1"
                    :margin-pages="2"
                    :click-handler="clickCallback"
                    :prev-text="''"
                    :next-text="''"
                    :container-class="'pagination'">
            </paginate>
        </div>

    </div>
</template>

<script>
  import {bus} from '../filter-parent';
  import {SaveToFavorites} from '../../../../scripts/save-to-favorites/save-to-favorites';
  import axios from 'axios';
  import moment from 'moment';

  const lang = $('body').data().locale;
  const enPrefix = lang === 'en' ? '/en' : '';

  moment.locale(lang);

  export default {
    name: "catalogue-component",
    props: {
      formData: '',
      offersData: '',

      enPrefix: '',

      authCheck: '',

      dataRouteIndex: '',
    },
    data: function () {
      return {
        /**
         * Auth check  variable - handles User Log In/ Log Out
         */
        authentication: this.authCheck,

        //**** Loads Data from DB *****//
        offers: this.offersData,
        formState: this.formData,
        prefixEn: enPrefix,

        placeholderImg: '/assets/images/placeholders/placeholder.jpg',

        //**** Route to single item & Pagination default state *****//
        routeToView: this.dataRouteIndex + this.offersData.slug,

        pageCount: 1,
        perPage: 10,
        currentPage: 1,
        lastPage: 1,
        page: 5,

        /**
         * Translations
         */
        lang: jsLangs,

        noResults: false,
      }
    },
    methods: {
      fetchOffers: function () {
        const selectCity = $("#select_city");
        const getFormData = sessionStorage.getItem('State');
        this.formState = JSON.parse(getFormData);

        if(this.formState) {
          this.formState['limit'] = null;
        }

        this.currentPage = this.formState !== null ? this.formState.page : 1;

        if (getFormData) {
          axios
            .get(enPrefix + '/api/properties', {params: this.formState})
            .then((response) => {
              /**
               * Check for No Results
               */
              (response.data.data.length === 0 ? this.noResults = true : this.noResults = false);

              this.offers = JSON.parse(JSON.stringify(response.data.data));

              return response;

            })
            .then((response) => {

              /**
               * Calculate Pagination Elements - Default State
               */
              this.pageCount = response.data.meta.last_page;
              this.lastPage = response.data.meta.last_page;

              /**
               * Call 'saveToFavorites' after successful request
               */
              SaveToFavorites();

              setTimeout(() => {
                selectCity.selectpicker('render');
                selectCity.selectpicker('refresh');
              }, 0);

              setTimeout(() => $("#preloaderSmall").fadeOut('slow'), 600);

            })
            .catch((err) => console.log(err));
        }
      },

      /**
       * Pagination
       */
      clickCallback: function (pageNum) {

        this.currentPage = Number(pageNum);

        if (this.currentPage >= this.lastPage) {
          this.currentPage = this.lastPage;
        }

        if(this.formState) {
          this.formState['page'] = this.currentPage;
        } else {
          this.formState = {
            page: this.currentPage
          }
        }
        sessionStorage.setItem('State', JSON.stringify(this.formState));

        axios
          .get(enPrefix + `/api/properties`, {params: {...this.formState}})
          .then((response) => {
            this.offers = response.data.data;
          })
          .catch((error) => console.log(error));
      },

      stateUpdate: function () {
        /**
         * Event bus - Watch for emitted value
         */
        bus.$on('searchResults', (response) => {
          const getFormData = JSON.parse(sessionStorage.getItem('State'));
          if(getFormData) {
            if(getFormData['page']) {
              this.currentPage = getFormData['page'];
            } else {
              this.currentPage = 1;
            }
          }
          const selectCity = $("#select_city");

          /**
           * Check for No Results
           */
          (response.data.data.length === 0 ? this.noResults = true : this.noResults = false);

          /**
           * Calculate Pagination Elements - After Search
           */
          this.pageCount = response.data.meta.last_page;
          this.lastPage = response.data.meta.last_page;

          this.offers = JSON.parse(JSON.stringify(response.data.data));

          /**
           * Call 'saveToFavorites' after successful request
           */
          SaveToFavorites();

          setTimeout(() => {
            selectCity.selectpicker('render');
            selectCity.selectpicker('refresh');
          }, 0);

          setTimeout(() => $("#preloaderSmall").fadeOut('slow'), 600);
        });

        bus.$on('searchFilters', (formState) => {
          console.log("TEST Search");
          this.formState = formState;
        });
      },

      /**
       * Helpers - Debugging
       */
      log: function (value) {
        console.log(value);
      },
    },
    mounted() {
      /**
       * Init Methods ***/
      $('[data-toggle="tooltip"]').tooltip();
      this.fetchOffers();
      this.stateUpdate();

      bus.$emit('componentLoaded', true);
    },
  }
</script>
